import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { IconButton } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';

import {
  PickerPanel,
  PickerTabsHeader,
  PickerTabs,
} from './styles';
import texts from './texts.json';
import IngredientSearchTab from './IngredientSearchTab';
import AIIngredientSearchTab from './AIIngredientSearchTab';

const PICKER_TABS = {
  search: { id: 'search', label: texts.searchTabLabel },
  ai: { id: 'ai', label: texts.aiTabLabel },
};

const IngredientPickerPanel = ({
  value,
  onChange,
  ingredients,
  isLoading,
  loadError,
  onRetryLoad,
  onClose,
  onAISearch,
}) => {
  const [activeTab, setActiveTab] = useState(Object.keys(PICKER_TABS)[0]);

  return (
    <PickerPanel>
      <PickerTabsHeader>
        <PickerTabs
          tabsConfig={PICKER_TABS}
          selectedTab={activeTab}
          onSelectTab={setActiveTab}
        />
        <IconButton size="small" onClick={onClose}>
          <CloseIcon fontSize="small" />
        </IconButton>
      </PickerTabsHeader>
      {activeTab === PICKER_TABS.search.id && (
        <IngredientSearchTab
          value={value}
          onChange={onChange}
          ingredients={ingredients}
          isLoading={isLoading}
          loadError={loadError}
          onRetryLoad={onRetryLoad}
        />
      )}
      {activeTab === PICKER_TABS.ai.id && (
        <AIIngredientSearchTab
          value={value}
          onChange={onChange}
          onAISearch={onAISearch}
        />
      )}
    </PickerPanel>
  );
};

IngredientPickerPanel.propTypes = {
  value: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  })).isRequired,
  onChange: PropTypes.func.isRequired,
  ingredients: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    category: PropTypes.string,
  })).isRequired,
  isLoading: PropTypes.bool,
  loadError: PropTypes.bool,
  onRetryLoad: PropTypes.func,
  onClose: PropTypes.func.isRequired,
  onAISearch: PropTypes.func.isRequired,
};

IngredientPickerPanel.defaultProps = {
  isLoading: false,
  loadError: false,
  onRetryLoad: () => {},
};

export default IngredientPickerPanel;
